const countries = () => {
  let countries = [
    {
      country_name: "USA",
      currency_code: "USD",
      dialog_title: "The US",
      full_country_name: "United States",
      geo: "US",
      human_country: "US",
      locale: "en-US",
      site_country: "us",
      url: "jewlr.com",
    },
    {
      country_name: "Canada",
      currency_code: "CAD",
      dialog_title: "Canada",
      full_country_name: "Canada",
      geo: "CA",
      human_country: "CA",
      locale: "en-CA",
      site_country: "ca",
      url: "jewlr.com/ca",
    },
    {
      country_name: "Australia",
      currency_code: "AUD",
      dialog_title: "Australia",
      full_country_name: "Australia",
      geo: "AU",
      human_country: "AU",
      locale: "en-AU",
      site_country: "au",
      url: "jewlr.com/au",
    },
    {
      country_name: "United Kingdom",
      currency_code: "GBP",
      dialog_title: "The UK",
      full_country_name: "United Kingdom",
      geo: "GB",
      human_country: "UK",
      locale: "en-GB",
      site_country: "uk",
      url: "jewlr.com/uk",
    },
  ]
  if (sl.config.global_e_new_countries) {
    countries = [
      ...countries,
      {
        country_name: "Germany",
        currency_code: "EUR",
        dialog_title: "Germany",
        full_country_name: "Germany",
        geo: "DE",
        human_country: "DE",
        locale: "de-DE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Hong Kong",
        currency_code: "HKD",
        dialog_title: "Hong Kong",
        full_country_name: "Hong Kong",
        geo: "HK",
        human_country: "HK",
        locale: "en-HK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Italy",
        currency_code: "EUR",
        dialog_title: "Italy",
        full_country_name: "Italy",
        geo: "IT",
        human_country: "IT",
        locale: "it-IT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Japan",
        currency_code: "JPY",
        dialog_title: "Japan",
        full_country_name: "Japan",
        geo: "JP",
        human_country: "JP",
        locale: "ja-JP",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Poland",
        currency_code: "PLN",
        dialog_title: "Poland",
        full_country_name: "Poland",
        geo: "PL",
        human_country: "PL",
        locale: "pl-PL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Singapore",
        currency_code: "SGD",
        dialog_title: "Singapore",
        full_country_name: "Singapore",
        geo: "SG",
        human_country: "SG",
        locale: "en-SG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Spain",
        currency_code: "EUR",
        dialog_title: "Spain",
        full_country_name: "Spain",
        geo: "ES",
        human_country: "ES",
        locale: "es-ES",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Sweden",
        currency_code: "SEK",
        dialog_title: "Sweden",
        full_country_name: "Sweden",
        geo: "SE",
        human_country: "SE",
        locale: "sv-SE",
        site_country: "int",
        url: "jewlr.com/int",
      },
    ]
  }
  return countries
}

export default countries
